import React from "react";

import { SkeletonLoader } from "@merge-api/merge-javascript-shared";

type TableSkeletonLoaderProps = {
  cols?: number;
  rows?: number;
  size?: "small" | "large";
};
const TableSkeletonLoader = ({ cols = 7, rows = 5, size = "small" }: TableSkeletonLoaderProps) => {
  const skeletonRows = Array.from({ length: rows }).map((_, i) => (
    <tr key={`issue-skel-row-${i}`}>
      <td colSpan={cols} className={size === "large" ? "h-[68px]" : "h-[55px]"}>
        <SkeletonLoader height={size === "large" ? 36 : 24} borderRadius={8} fullWidth />
      </td>
    </tr>
  ));

  return <>{skeletonRows}</>;
};
export default TableSkeletonLoader;
